import script from "./CCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./CCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./CCheckbox.vue?vue&type=style&index=0&id=bd8d4fe0&lang=scss"

const __exports__ = script;

export default __exports__